/* eslint-disable react/forbid-foreign-prop-types */
import PropTypes from 'prop-types';
import PaletteProp from '../../proptypes/palette';
import ThemeProps from '../../proptypes/groups/theme';

export const propTypes = {
  palette: PaletteProp,
  type: PropTypes.oneOf(['eurostar', 'circular']),
  size: PropTypes.number,
  theme: PropTypes.shape({
    ...ThemeProps.propTypes
  })
};

export const propDescriptions = {
  palette: 'Color of the spinner #visual',
  type: 'Style of the spinner #visual',
  size: 'Size of the spinner #visual',
  theme: ThemeProps.propDescription
};

export const defaultProps = {
  palette: 'default',
  type: 'eurostar',
  size: 30,
  theme: ThemeProps.defaultProps
};
